// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fx","body_styleRed":"c-a_fy"};